import { Checkbox } from '@/components/ui/checkbox';
import { Field, FieldDescription, FieldLabel } from '@/components/ui/field';
import { Label } from '@/components/ui/label';
import { SimpleSelect } from 'components/MapPage/CorporateViewTabs/EventsTab/automationFormControls';
import {
  FEED_UNIT_OPTIONS,
  type ExternalFeedDef,
  type FeedUnits,
} from 'components/MapPage/CorporateViewTabs/EventsTab/externalFeeds';

/**
 * Pick Open Weather Map feeds to add as Hub layers. Each picked feed becomes
 * its own layer, showing the forecast at every org asset.
 */
export function AddOpenWeatherMapFeeds({
  feeds,
  selectedProducts,
  onToggleProduct,
  units,
  onUnitsChange,
}: {
  feeds: ExternalFeedDef[];
  selectedProducts: Set<string>;
  onToggleProduct: (product: string, checked: boolean) => void;
  units: FeedUnits;
  onUnitsChange: (units: FeedUnits) => void;
}) {
  return (
    <div className="dark tw:flex tw:flex-col tw:gap-3 tw:text-foreground">
      <p className="tw:m-0 tw:text-xs tw:text-muted-foreground">
        Global forecasts at each of your organization&apos;s assets. Data
        refreshes when you turn the layer on or press refresh.
      </p>
      <div className="tw:flex tw:flex-col tw:gap-2">
        {feeds.map((feed) => {
          const id = `owm-feed-${feed.product}`;
          return (
            <div key={feed.product} className="tw:flex tw:items-start tw:gap-2">
              <Checkbox
                id={id}
                checked={selectedProducts.has(feed.product)}
                onCheckedChange={(checked) =>
                  onToggleProduct(feed.product, checked === true)
                }
              />
              <Label
                htmlFor={id}
                className="tw:flex tw:flex-col tw:items-start tw:gap-0.5"
              >
                <span className="tw:text-sm">{feed.label}</span>
                <span className="tw:text-xs tw:font-normal tw:text-muted-foreground">
                  {feed.description}
                </span>
              </Label>
            </div>
          );
        })}
      </div>
      <Field className="tw:max-w-xs">
        <FieldLabel>Units</FieldLabel>
        <SimpleSelect
          value={units}
          onChange={(next) => onUnitsChange(next as FeedUnits)}
          options={FEED_UNIT_OPTIONS}
        />
        <FieldDescription>
          You can switch units later on the layer.
        </FieldDescription>
      </Field>
    </div>
  );
}
